import React from 'react'
import { isEmpty, sort, ascend, prop } from 'ramda'
import { useFetch } from '../../../../../../../../hooks'
import { getData } from '../../../../../../../../helpers'
import { Card, CardHeader } from '../../../../../../../../components/Card'
import Buttons from '../../../../../../../../modules/Buttons'
import Button from '../../../../../../../../components/inputs/Button'
import Modal from '../../../../../../../../components/Modal'
import Dateline from '../../../../../../../../modules/Dateline'
import Icon from '../../../../../../../../components/Icon'
import { StyledSymbols, StyledSymbolsHeader, StyledSymbolsList, StyledSymbolsItem, StyledText } from './styled'

const OMR = ({ omr }) => {
    const { response } = useFetch({
        url: `/get_omr_modal`,
        method: 'GET'
    })
    const modal = getData(response)
    return (
        <Card>
            <CardHeader>
                {omr.title}
                <Modal
                    renderOpenButton={
                        ({ handleToggleIsOpenModal }) => (
                            <Icon name='tooltip' pointer onClick={handleToggleIsOpenModal} />
                        )
                    }
                >
                    {
                        ({ handleToggleIsOpenModal }) => (
                            <StyledSymbols>
                                <StyledSymbolsHeader>
                                    {modal.title}
                                </StyledSymbolsHeader>
                                <StyledSymbolsList>
                                    {
                                        sort(ascend(prop('order')), modal.symbols).map(symbol => (
                                            <StyledSymbolsItem
                                                key={symbol.order}
                                            >
                                                <Icon name={symbol.icon} number={symbol.number} />
                                                <StyledText>{symbol.label}</StyledText>
                                            </StyledSymbolsItem>
                                        ))
                                    }
                                </StyledSymbolsList>
                                <Buttons>
                                    <Button
                                        type='button'
                                        onClick={handleToggleIsOpenModal}
                                        fullWidth
                                    >
                                        {modal['form-button']}
                                    </Button>
                                </Buttons>
                            </StyledSymbols>
                        )
                    }
                </Modal>
            </CardHeader>
            {
                !isEmpty(omr.data) &&
                <Dateline
                    data={omr.data}
                />
            }
        </Card>
    )
}

export default OMR
